import React from 'react';
import { OrderSummary } from '../../../types';
import { OrderCard } from '../molecules';
import './OrdersList.css';

interface OrdersListProps {
  orders: OrderSummary[];
  onOrderClick?: (order: OrderSummary) => void;
  onEdit?: (order: OrderSummary) => void;
  loading?: boolean;
  error?: string | null;
  className?: string;
}

const OrdersList: React.FC<OrdersListProps> = ({ 
  orders, 
  onOrderClick, 
  onEdit,
  loading = false,
  error = null,
  className = '' 
}) => {
  if (loading) {
    return (
      <div className={`orders-list loading ${className}`}>
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading orders...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`orders-list error ${className}`}>
        <div className="error-state">
          <h3>Error Loading Orders</h3>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className={`orders-list empty ${className}`}>
        <div className="empty-state">
          <h3>No Orders Found</h3>
          <p>No orders match your current filters.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`orders-list ${className}`}>
      <div className="orders-grid">
        {orders.map((order) => (
          <OrderCard
            key={order.id}
            order={order}
            onClick={onOrderClick}
            onEdit={onEdit}
          />
        ))}
      </div>
    </div>
  );
};

export default OrdersList;
